export enum Affiliate {
  gpt = 'gpt',
  normal = 'normal',
  uniprep = 'uniprep',
}
